import { render } from "./AddGroupDialog.vue?vue&type=template&id=1fe71482"
import script from "./AddGroupDialog.vue?vue&type=script&lang=js"
export * from "./AddGroupDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__